


























































import { Vue, Component } from 'vue-property-decorator'
import { XInput, XButton } from '@lx-frontend/cvux'
import util from '@/common/util'
import { CarStatus } from '@/common/commonType'
import Alert from '../components/Alert.vue'
import SubmitDialog, { ErrType } from '../components/vinSubmitDialog.vue'
import Axios from 'axios'

enum PAGESTATUS {
  NOTOUT, // 未放行
  INREVIEW, // 审核中
  RELEASED // 已放行
}

const throttle = require('lodash.throttle')

@Component({
  components: {
    XInput,
    XButton,
    Alert,
    SubmitDialog
  }
})
export default class UnlabeledDischarging extends Vue {
  vin:string = ''

  PAGESTATUS = PAGESTATUS

  pageStatus:PAGESTATUS | null = null

  selectDeviceId: Number | null = null

  allInfo = {}

  exitDevicesList = [] // 车场出口设备列表

  alertInfo = {
    title: '',
    text: ''
  }

  get pageStatusInfo() {
    const iconMap = {
      [PAGESTATUS.INREVIEW]: {
        icon: require('../../stylesheets/images/time-status.png'),
        text: '车辆审核中',
        tip: '车辆放行还在审核中，如有疑问请联系接待人'
      },
      [PAGESTATUS.NOTOUT]: {
        icon: require('../../stylesheets/images/warn-status.png'),
        text: '车辆暂未放行',
        tip: '当前车辆没有放行，如有疑问请联系接待人'
      },
      [PAGESTATUS.RELEASED]: {
        icon: require('../../stylesheets/images/success-status.png'),
        text: '车辆已放行',
        tip: '车辆放行已审核通过，等待确认放行开闸离场 如有疑问请联系接待人'
      }
    }
    if (![PAGESTATUS.INREVIEW, PAGESTATUS.NOTOUT, PAGESTATUS.RELEASED].includes(this.pageStatus as PAGESTATUS)) return {}
    return iconMap[this.pageStatus as PAGESTATUS]
  }

  get submitDisabled() {
    return this.pageStatus !== PAGESTATUS.RELEASED
  }

  created () {
    this.getExitDevices()
  }

  showDialog(type: ErrType) {
    // @ts-ignore
    this.$refs.submitDialog.show(type)
  }

  async getExitDevices() {
    const { code, data } = await this.$rest.barriergate.getExitDevices()
    if (code !== 0) {
      util.showToast('获取车场出口信息失败')
      return
    }
    this.exitDevicesList = data
    if (data.length === 1) this.selectDeviceId = data[0].id
  }

  handleDevice(id: Number) {
    this.selectDeviceId = id
  }

  handleInput() {
    if (this.vin.length !== 7) return
    if (!util.regexpMap.regexp_car_vin7.test(this.vin)) {
      util.showToast('请输入正确的车架号后7位')
      return
    }
    this.clearInfo()
    this.getVinInfo(this.vin)
  }

  handleBlur() {
    if (!util.regexpMap.regexp_car_vin7.test(this.vin)) {
      util.showToast('请输入正确的车架号后7位')
    }
  }

  clearInfo() {
    this.pageStatus = null
  }

  async getVinInfo(vin: string) {
    this.switchLoading({ status: true, text: '查询中...' })
    const { code, data, message } = await this.$rest.barriergate.getUnlicensedCarExiting({ short_vin: vin.toLocaleUpperCase() })
    this.switchLoading({ status: false })
    if (code !== 0 && code !== 1404) {
      this.alertInfo = {
        title: '温馨提示',
        text: message || '请求错误，请稍后'
      }
      // @ts-ignore
      this.$refs.alertRef.changeShow(true)
      return
    }
    if (code === 1404) {
      this.pageStatus = PAGESTATUS.NOTOUT
      return
    }
    // 详细见需求文档
    // 详细见需求文档
    const statusType1 = CarStatus.AUDITING // 审核中
    const statusType2 = CarStatus.APPROVED // 已通过

    if (data.status === statusType2 && data.can_exit) this.pageStatus = PAGESTATUS.RELEASED
    else if (data.status === statusType1) this.pageStatus = PAGESTATUS.INREVIEW
    else this.pageStatus = PAGESTATUS.NOTOUT

    this.allInfo = data
  }

  getOnline() {
    // eslint-disable-next-line promise/param-names
    return new Promise(reslove => {
      this.$wechat.wx.getNetworkType({
        success(res: { networkType: string }) {
          return reslove(res.networkType !== 'none')
        },
        fail() {
          return reslove(true)
        }
      })
    })
  }

  async handleConfirm() {
    if (this.submitDisabled) return
    if (!this.selectDeviceId) {
      util.showToast('请选择车场出口')
      return
    }
    const wxOnline = await this.getOnline()
    // 网络是否正常
    if (!wxOnline || !navigator.onLine) {
      this.showDialog(ErrType.NETERR)
      return
    }
    // @ts-ignore
    const { id } = this.allInfo
    this.switchLoading({ status: true, text: '开闸中...' })
    const data = await this.$rest.barriergate.createUnlicensedExit(id)({ device_id: this.selectDeviceId })
    this.switchLoading({ status: false })
    const { code } = data

    if (code === 1001) {
      this.showDialog(ErrType.NOTGETCAR)
      return
    }
    if (code !== 0) {
      this.showDialog(ErrType.OPENERR)
      return
    }

    this.$router.push({
      path: '/new/back/page',
      query: {
        status: 'success',
        tips: '已为您开闸放行',
        title: '无牌放行',
        backLink: '/storeVehicle/index'
      }
    })
  }
}
